export default __webpack_public_path__ + "high-density.png";